export default __webpack_public_path__ + "static/media/logo.ad32ae3e.png";